import { Injectable, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class SectionFormService implements OnDestroy {
  private cancelNotifier = new Subject<void>();
  public cancelEvent$ = this.cancelNotifier.asObservable();

  private leaveNotifier = new Subject<boolean>();
  public allowPageLeave$ = this.leaveNotifier.asObservable();

  private saveFormToChecklistNotifier = new Subject<void>();
  public saveForm$ = this.saveFormToChecklistNotifier.asObservable();

  constructor() {}
  
  ngOnDestroy() {
    this.cancelNotifier.next();
    this.cancelNotifier.complete();
    this.leaveNotifier.next(false);
    this.leaveNotifier.complete();
    this.saveFormToChecklistNotifier.next();
    this.saveFormToChecklistNotifier.complete();
  }
  
  notifyCancel() {
    this.cancelNotifier.next();
  }

  allowLeave(leave: boolean) {
    this.leaveNotifier.next(leave);
  }

  saveFormToChecklist() {
    this.saveFormToChecklistNotifier.next();
  }
}